<template>
    <div class="userPage">
        <b-row class="pageTitle">
            <b-col cols="12" class="d-flex mb-3">
                <h3 class="m-0">Thành viên</h3>
                <b-button size="sm" variant="primary" class="ml-2" :to="{path:'/users/new'}" @click="trackingNewMember()">Tạo mới</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <transition name="slide">
                    <b-card>
                        <div slot="header">
                            <b-row align-h="between">
                                <b-col cols="6">
                                    <div>
                                      <span v-if="pages && pages.total >0" >Tổng số <b>{{pages.total}}</b> thành viên</span>
                                    </div>
                                </b-col>
                                <b-col cols="6" class="justify-content-end d-flex">
                                    <div class="search-area">
                                        <b-form @submit="searchForm" class="justify-content-end d-flex">
                                            <b-form-select v-model="filter.status" :options="filter.statusArr" class="mr-2"></b-form-select>
                                            <b-input-group class="mb-0">
                                                <b-form-input v-model="filter.search" placeholder="Tìm kiếm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" text="Button" variant="primary" type="submit" >
                                                        <i class="icon-magnifier icons font-lg  pl-1 pr-1"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form>
                                    </div>
                                </b-col>
                            </b-row>

                        </div>
                        <div v-if="data">
                            <b-table bordered responsive="sm" :items="data" :fields="fields" :hover="true" style="min-height: 560px">
                                <template slot="HEAD_checked" slot-scope="data">
                                    <b-form-checkbox v-model="selectAll" @change="selectAllToggle()"/>
                                </template>
                                <template slot="checked" slot-scope="option">
                                    <b-form-checkbox v-model="selected" :value="option.item._id"/>
                                </template>
                                <template slot="name" slot-scope="option">
                                    <strong><b-link :to="{ path: '/users/' + option.item._id}">{{option.item.name}}</b-link></strong>

                                </template>
                                <template slot="group" slot-scope="option">
                                   {{ (option.item.userGroup && option.item.userGroup[0]) ? option.item.userGroup[0].title : "N/A"}}
                                </template>

                              <template slot="inactive_days" slot-scope="option">
                                  <span>{{ formatLastLoginDiff(option.item.last_login) }}</span>
                              </template>

                              <template slot="filter_count" slot-scope="option">
                                  <span>{{ option.item.filters.length }}</span>
                              </template>

                                <template slot="status" slot-scope="option">
                                    <b-badge pill class="p-2" size="md" variant="success" v-if="option.item.status === 1">Đang hoạt động</b-badge>
                                    <b-badge pill class="p-2" size="md" variant="danger" v-if="option.item.status === 2">Ngừng hoạt động</b-badge>
                                </template>

                                <template slot="action" slot-scope="option">
                                  <div class="d-flex justify-content-center">
                                    <b-button-group size="sm" class="btn-group-esm">
                                      <b-button :to="{ path: '/users/' + option.item._id}" variant="none" size="sm">
                                        <i class="cui-pencil"></i>
                                        Sửa
                                      </b-button>
                                      <b-button v-if="isSuperAdmin"
                                                @click="deleteData(option.item._id)"
                                                variant="danger"
                                                class="ml-2">Xóa</b-button>
                                      <b-button @click="showResetStatus3(option.item._id)" variant="danger" class="ml-2" v-if="option.item.status==3">Mở tạm khóa</b-button>
                                    </b-button-group>
                                  </div>
                                </template>

                            </b-table>
                            <nav v-if="pages && pages.totalPages > 1" class="d-flex justify-content-center">
                                <b-pagination size="sm" :total-rows="pages.total" :per-page="pages.pageSize" v-model="pages.page"/>
                            </nav>
                        </div>

                        <div v-bind:class="{'ptt-loading':loading}" v-else>
                            <b-alert show variant="warning">Không có tài khoản</b-alert>
                        </div>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>

</template>

<script>
export default {
  name: 'UserList',
  data: () => {
    return {
      data: null,
      pages: {
        page: 1
      },
      limit: 20,
      action: 0,
      actions: [
        "Hành động",
        "Xóa các lựa chọn"
      ],
      fields: [
        {key: "name", label: "Tên", thStyle: "width: 200px"},
        {key: "email", label: "Email"},
        {key: "login_last_week", label: "Lần login 1 tuần trước", thStyle: "width: 90px"}, // int
        {key: "login_last_month", label: "Lần login 1 tháng trước", thStyle: "width: 90px"}, // int
        {key: "inactive_days", label: "Đã không đăng nhập", thStyle: "width: 90px"}, // since : e.g 6 days ago, ...
        {key: "last_login", label: "Đăng nhập lần cuối", thStyle: "width: 120px", formatter: "getDate"}, // date dd-mm-YYYY H:i:s
        {key: "last_filter", label: "Lần lọc cuối", thStyle: "width: 120px"}, // date dd-mm-YYYY H:i:s
        {key: "filter_count", label: "Số bộ lọc", thStyle: "width: 100px;"}, // int
        {key: "device_limit", label: "Số thiết bị", thStyle: "width: 100px;"}, // int
        {key: "createdAt", label: "Cập nhập", thStyle: "width: 120px;", formatter: "getDate"}, // date dd-mm-YYYY H:i:s
        {key: "status", label: "Trạng thái", thStyle: "width: 100px;"},
        {key: "action", label: "", thStyle: "width: 50px;"}
      ],
      selected: [],
      selectAll: false,

      loading: false,
      filter: {
        search: '',
        status: null,
        statusArr: [
          {value: null, text: 'Tất cả'},
          {value: 1, text: 'Đang hoạt dộng'},
          {value: 2, text: 'Ngừng hoạt động'},
        ]
      },
      q: {}

    }
  },
  computed: {
    isAdmin() {
      return this.$userLogged && this.$userLogged.group_name === 'administrator'
    },
    isSuperAdmin() {
      return this.$userLogged && this.$userLogged.group_name === 'supper-admin'
    },

  },
  watch: {
    "pages.page": function (val) {
      this.getData(val);
    },
    "filter.status": function (val) {
      if (val) {
        this.q["status"] = val;
      } else {
        delete this.q.status;
      }
      this.getData();
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = null) {
      this.loading = true;

      try {
        let params = {
          sort: '-createdAt',
        }
        if (page > 0) {
          params.page = page
        }
        // xử lý filter
        if (this.filter) {
          let query = {}
          let {search, status} = this.filter
          if (search.length >= 1) {
            // query.name = {
            //   $regex: search
            // }
            // query.email = {
            //   $regex: search
            // }
          }
          if (status) {
            query.status = status;
          }


          if (Object.keys(query).length > 0) {
            params.query = query;
          }
          // Cần full text search
          params.search = search
        }

        const user = this.$cookies.get('user');
        this.$gtag.event('get_member_list', {
          event_category: 'list_events',
          event_label: 'List members',
          user_type: 'admin',
          user_id: user?._id,
          qs: JSON.stringify(params) || null
        });

        let {data} = await this.$axios.get(this.$configs.api + '/api/v4/cp/users', {params})

        if (data) {
          this.pages = data
        }
        if (data && data.rows) {
          this.data = data.rows
        }
        if (data && data.totalPages) {
          this.pages.count = data.totalPages
        }
      } catch (err) {
        //TODO: show err message
      } finally {
        this.loading = false
      }
    },
    selectAllToggle() {
      this.selected = [];
      if (!this.selectAll) {
        for (let index in this.data) {
          this.selected.push(this.data[index]._id);
        }
      }
    },
    searchForm(evt) {
      evt.preventDefault();
      const user = this.$cookies.get('user');
      this.$gtag.event('click_search_member', {
        event_category: 'click_events',
        event_label: 'Search members',
        user_type: 'admin',
        user_id: user?._id,
        filter_search: this.filter.search,
        filter_status: this.filter.status,
      });
      this.getData();
    },
    deleteData(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selected.length) {
          ids = this.selected;
        } else {
          this.$toasted.show("Vui lòng chọn dữ liệu cần xóa", {
            type: "error",
            duration: 5000
          });
          return false;
        }
      }

      //Xoa du lieu
      this.$toasted.show("Bạn có chắc chắn muốn xóa", {
        type: "info",
        theme: "outline",
        duration: 10000,
        action: [
          {
            text: 'Hủy',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          {
            text: 'Xóa',
            // router navigation
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
              this.deleteAction(ids);
            }
          }
        ]
      })
    },
    deleteAction(ids) {
      this.$http.delete(this.$configs.api + '/api/user', {
        data: {ids}
      })
        .then(respons => {
          this.getData();
          this.$toasted.success("Xóa thành công", {
            duration: 5000
          });
        })
        .catch(err => {
          this.$toasted.error(err.message, {
            duration: 5000
          });
        });
    },
    runAction() {
      switch (this.action) {
        case 1:
          this.deleteData();
        default:
          return;
      }
    },
    showResetStatus3(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selected.length) {
          ids = this.selected;
        } else {
          this.$toasted.show("Vui lòng chọn dữ liệu cần Mở tạm khóa", {
            type: "error",
            duration: 5000
          });
          return false;
        }
      }

      //Xoa du lieu
      this.$toasted.show("Bạn có chắc chắn muốn Mở tạm khóa", {
        type: "info",
        theme: "outline",
        duration: 10000,
        action: [
          {
            text: 'Hủy',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          {
            text: 'Mở',
            // router navigation
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
              this.resetStatus3Action(ids);
            }
          }
        ]
      })
    },
    async resetStatus3Action(ids) {
      try {
        const {data} = await this.$axios.post(this.$configs.api + '/api/v4/cp/users/reset-status',{ ids })
        if (data) {
          this.$toasted.success("Mở tạm khóa thành công", {
            duration: 5000
          });
          await this.getData()
        }
      } catch (err) {
        this.$toasted.error(err.message, {
          duration: 5000
        });
      }
    },
    getDate(date){
      return this.$moment(date).format('DD-MM-YYYY, H:m')
    },
    trackingNewMember() {
      const user = this.$cookies.get('user');
      this.$gtag.event('click_new_member', {
        event_category: 'click_events',
        event_label: 'New member button',
        user_type: 'admin',
        user_id: user?._id,
      });
    },
    formatLastLoginDiff(lastLogin) {
      if ('Invalid date' === lastLogin || !lastLogin) return;
      const now = this.$moment();
      const lastLoginDate = this.$moment(lastLogin);
      const diffDays = now.diff(lastLoginDate, 'days');
      const diffHours = now.diff(lastLoginDate, 'hours');

      if (diffDays >= 1) {
        return `${diffDays} ngày trước`;
      } else {
        return `${diffHours} giờ trước`;
      }
    },

  }
}
</script>
